module.exports = __webpack_public_path__ + "img/logo.bd5d82f6.svg";